export const centerOfContainer = (width: number, height: number) => {
  return {
    centerX: width / 2,
    centerY: height / 2
  };
};
